import React from 'react';

import logo from "../../../src/assets/img/uniexpo.webp";

import { ArrowLong, Calendar } from '../../assets/img/svg/icons';

interface NewsComponentProps {
    title: string;
    excerpt?: string;
    date: Date;
    slug: string;
    thumbnail: string;
    className?: string;
    type?: string;
}

const News: React.FC<NewsComponentProps> = ({ title, excerpt, date, slug, thumbnail, className, type }) => {
    return (
        <a href={`/blog/${slug}`} title={title} className={`group ${className}`}>
            <div className={`bg-[#EEF9FA80] w-full overflow-hidden ${type === 'simple' ? 'h-36 xl:h-44 rounded-t-2xl' : 'h-52 xl:h-64 2xl:h-72 rounded-2xl'}`}>
                {thumbnail ? 
                    <img src={thumbnail} alt={title} className='h-full w-full object-cover group-hover:scale-105 transition-all duration-200' />
                : 
                    <img src={logo} alt="Logo Uniexpo" className='h-1/2 w-1/2 object-contain pt-4 object-center group-hover:scale-105 transition-all duration-200' />
                }
            </div>

            <div className={`bg-[#F2F5FF] drop-shadow-sm pl-6 pt-6 pb-10 pr-12 overflow-hidden transition-all duration-200 ${type === 'simple' ? 'rounded-b-2xl' : '-mt-24 group-hover:-translate-y-2 max-w-[calc(100%-1.5rem)] md:max-w-[80%] rounded-2xl group-even:ml-3 group-even:mr-auto group-odd:mr-3 group-odd:ml-auto'}`}>
                <div className="flex items-center text-sm text-[#9D104B] font-semibold gap-2">
                    <Calendar className='h-5 w-5 object-contain'/>
                    {date.toLocaleDateString('pt-br', { day: '2-digit', month: '2-digit', year: '2-digit' }).replace(/\//g, '.')}
                </div>

                <h3 className="font-semibold mt-2 text-balance">{title}</h3>
                <p className='text-sm'>{excerpt}</p>

                {type === 'simple' ? 
                    <span className='bg-main-pink inline-block mt-6 rounded-full text-white text-sm px-8 py-1.5 transition-all duration-200 group-hover:bg-main-blue'>
                        Leia mais
                    </span>
                : 
                <span className="bg-main-pink absolute bottom-0 right-0 w-12 h-8 flex items-center justify-center transition-all duration-200 group-hover:bg-main-blue">
                    <ArrowLong />
                </span>
                }
            </div>
        </a>
    );
};

export default News;
